const { createObject, createString, traversePropertiesString } = require('../../shared');

module.exports.agent = function (appData, formData, outData, formDataKey){

  if (!outData.error && !createObject(appData, "agent", {})) {
    outData.error = "Cannot create agent info";
  }

  if (!outData.error && !createString(appData.agent, "name", traversePropertiesString(formData,['agent','MBA','name']), true)) {
    outData.error = "Missing Agent Name for MBA";
  }

  if (!outData.error && !createString(appData.agent, "phone", traversePropertiesString(formData,['agent','MBA','phone']), true)) {
    outData.error = "Missing Agent Phone for MBA";
  }

  if (!outData.error && !createString(appData.agent, "code", traversePropertiesString(formData,['agent','MBA','code']), true)) {
    outData.error = "Missing Agent Code for MBA";
  }

  if (!outData.error && !createString(appData.agent, "agencyCode", traversePropertiesString(formData,['agent','MBA','agencyCode']), true)) {
    outData.error = "Missing Agent's Agency Code for MBA";
  }

};


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/agent.js